import { render, staticRenderFns } from "./modulesTabs.vue?vue&type=template&id=214c3cc2"
import script from "./modulesTabs.vue?vue&type=script&lang=js"
export * from "./modulesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports